import type { ComponentSingleStyleConfig } from "@chakra-ui/react"

// BARNES Design System buttons (dist/css/buttons.css); chip look for selectable tags (search.css).
export const Button: ComponentSingleStyleConfig = {
  baseStyle: {
    fontFamily: "body",
    fontSize: "2xs",
    fontWeight: "semibold",
    letterSpacing: "wider",
    textTransform: "uppercase",
    lineHeight: 1,
    borderRadius: "lg",
    border: "1px solid",
    transitionProperty: "background, color, border-color",
    transitionDuration: "240ms",
    transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
    },
  },
  sizes: {
    sm: {
      minH: "36px",
      h: "auto",
      px: "4",
      fontSize: "3xs",
    },
    // fontSize is repeated in each size: Chakra's default sizes would otherwise override the base
    // one (md sets 16px).
    md: {
      minH: "controlH",
      h: "auto",
      // 24px instead of the design system's 32px: lighter in the back office (decided in review).
      px: "6",
      fontSize: "2xs",
    },
    // List toolbars (ADR 0003, D4): 40px, aligned with the compact search field (controlHSm).
    toolbar: {
      minH: "controlHSm",
      h: "controlHSm",
      px: "4",
      fontSize: "3xs",
    },
    // Chip (ChoiceTag): 36px, sentence case, 4px radius.
    round: {
      minH: "36px",
      h: "auto",
      px: "4",
      borderRadius: "sm",
      fontSize: "xs",
      fontWeight: "normal",
      letterSpacing: "wide",
      textTransform: "none",
    },
  },
  variants: {
    solid: {
      bg: "surfaceInverse",
      color: "textInverse",
      borderColor: "text",
      _hover: {
        bg: "transparent",
        color: "text",
        _disabled: { bg: "surfaceInverse", color: "textInverse" },
      },
      _active: {
        bg: "transparent",
        color: "text",
      },
    },
    outline: {
      bg: "transparent",
      color: "text",
      borderColor: "text",
      _hover: {
        bg: "surfaceInverse",
        color: "textInverse",
        _disabled: { bg: "transparent", color: "text" },
      },
      _active: {
        bg: "surfaceInverse",
        color: "textInverse",
      },
    },
    accent: {
      bg: "accent",
      color: "onAccent",
      borderColor: "accent",
      _hover: {
        bg: "accentHover",
        borderColor: "accentHover",
        _disabled: { bg: "accent", borderColor: "accent" },
      },
      _active: {
        bg: "accentHover",
        borderColor: "accentHover",
      },
    },
    ghost: {
      bg: "transparent",
      color: "text",
      borderColor: "transparent",
      _hover: {
        bg: "surfaceGreige",
        borderColor: "surfaceGreige",
      },
      _active: {
        bg: "surfaceGreige",
      },
    },
    transparent: {
      bg: "transparent",
      color: "text",
      borderColor: "transparent",
      _hover: {
        bg: "surfaceGreige",
        borderColor: "surfaceGreige",
      },
      _active: {
        bg: "surfaceGreige",
      },
    },
    link: {
      bg: "transparent",
      color: "text",
      borderColor: "transparent",
      minH: "auto",
      h: "auto",
      px: "0",
      fontSize: "sm",
      fontWeight: "semibold",
      letterSpacing: "normal",
      textTransform: "none",
      textDecor: "underline",
      _hover: {
        bg: "transparent",
        color: "accent",
      },
      _active: {
        bg: "transparent",
      },
    },
    selectable: {
      bg: "surface",
      color: "text",
      borderColor: "lineStrong",
      _hover: {
        borderColor: "text",
      },
    },
    selected: {
      bg: "surfaceInverse",
      color: "textInverse",
      borderColor: "text",
    },
  },
  defaultProps: {
    size: "md",
    variant: "solid",
  },
}
